/**
 * These properties must be the same in Next.js and the API.
 */
export const commonAppInfo = {
    appName: 'PXR',
    apiBasePath: '/auth',
    websiteBasePath: '/auth',
};
